<template src="./index.html"></template>
<script>
import minhead from '../../../../common/minHead/index.vue';
import SalesTaxReportTree from '../../../../common/SalesTaxReportTree/index.vue';
import SalesTaxReportbox from '../../../../common/SalesTaxReportbox/index.vue';
import { getdata } from './data.js';
import config from '../../../../../../configHttp.js';
import uploadFile from '../../../../common/uploadFile/index.vue';
import uploadFileplus from '../../../../common/uploadFileplus/index.vue';
import {
  querycell,
  writesave,
  startShenBao,
  forShengcdg,
  manuscriptqueryReportStep,
  manuscriptwriteimport,
  manuscriptUploadFile,
  annexadd,
  queryCheckData,
  financialReportHint, manuscriptSaveVerified
} from '../../../../../api/Draftgeneration.js';
import { querytemplatecell, getShuibDetailList, templatecellsave } from '../../../../../api/bbmb.js';
import { reportquerytrack } from '../../../../../api/xggj.js';
import { zcfg_fycx, zcfg_fetch } from '../../../../../api/zcfg.js';
import addzc from '../../../../common/addzc/index.vue';
import seezc from '../../../../common/seezc/index.vue';
import corporateIncomeTax_I from './corporateIncomeTax_I/index.vue';
import { getdata as getdataI } from './corporateIncomeTax_I/data.js';
import corporateIncomeTax_II from './corporateIncomeTax_II/index.vue';
import { getdata as getdataII } from './corporateIncomeTax_II/data.js';
import corporateIncomeTax_III from './corporateIncomeTax_III/index.vue';
import { getdata as getdataIII } from './corporateIncomeTax_III/data.js';
import corporateIncomeTax_VI from './corporateIncomeTax_VI/index.vue';
import { getdata as getdataVI } from './corporateIncomeTax_VI/data.js';
import corporateIncomeTax_V from './corporateIncomeTax_V/index.vue';
import { getdata as getdataV } from './corporateIncomeTax_V/data.js';
import ExportIncomeDifference from "../../../../common/SalesTaxReportbox/ExportIncomeDifference/index.vue";
export default {
    name: '',
    components: {
        ExportIncomeDifference,
        minhead,
        SalesTaxReportTree,
        SalesTaxReportbox,
        uploadFile,
        uploadFileplus,
        addzc,
        seezc,
        corporateIncomeTax_I,
        corporateIncomeTax_II,
        corporateIncomeTax_III,
        corporateIncomeTax_VI,
        corporateIncomeTax_V
    },
    props: {
        type: {
            type: String,
            default: ''
        },
        params: {
            type: Object,
            default: {}
        },
        sbqj: {
            type: String,
            default: ''
        },
        showbox: {
            type: Boolean,
            default: false
        },
        mintext: {
            type: String,
            default: '填写'
        },
        toseeUpdate: {
            type: Boolean,
            default: false
        },
        seeNow: {
            type: Boolean,
            default: false
        },
        suosq: {
            type: String,
            default: ''
        }
    },
    mounted() {
        if (this.toseeUpdate) {
            this.getShuibDetailList();
        } else {
            this.manuscriptqueryReportStep();
            // 查询校验所需数据
            queryCheckData({companyId: this.params.companyId, companyNo: this.params.companyNo, suosq: this.suosq}).then((res) => {
              if (res.data.code === 1) {
                this.checkData = res.data.data;
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
    },
    data: function () {
        return {
            treestate: '',
            statedata: [],
            treedata: getdata().treedata,
            choosetitleindex: '',
            formlist: getdata().formlist,
            headobj: {},
            choosecellCode: '',
            smtext: '',
            zcdata: [],
            Changed: 0,
            searchlistzc: getdata().searchlistzc,
            headDatazc: getdata().headDatazc,
            pagination: getdata().pagination,
            seezcformlist: getdata().seezcformlist,
            formdatazc: getdata().formdatazc, //form表单数据
            tableDataVI: [],
            //表一
            tableDataI: [],
            tableDataII: [],
            tableDatas: [],
            tableDatasv: [],
            tableDatasvi: [],
            tableDatasvii: [],
            IHead: [
                'sdsA_1_x_1',
                'sdsA_1_x_2',
                'sdsA_1_x_3',
                'sdsA_1_x_4',
                'sdsA_1_x_5',
                'sdsA_1_x_6',
                'sdsA_1_x_7',
                'sdsA_1_x_8',
                'sdsA_1_x_9'
            ],
            IIHead: ['sdsA_2_x_1', 'sdsA_2_x_2', 'sdsA_2_x_3', 'sdsA_2_x_4', 'sdsA_2_x_5', 'sdsA_2_x_6'],
            //表三
            tableDatavx: [],
            tableDataIII: [],
            IIIHead: [
                'sdsA_3_x_1',
                'sdsA_3_x_2',
                'sdsA_3_x_3',
                'sdsA_3_x_4',
                'sdsA_3_x_5',
                'sdsA_3_x_6',
                'sdsA_3_x_7',
                'sdsA_3_x_8',
                'sdsA_3_x_9',
                'sdsA_3_x_10',
                'sdsA_3_x_11',
                'sdsA_3_x_12',
                'sdsA_3_x_13',
                'sdsA_3_x_14',
            ],
            choosetable: '',
            chooseindex: '',
            choosecolum: '',
            delCellsI: [],
            delCellsIII: [],
            errdiag: false,
            errarr: [],
            // 保存校验所需数据
            checkData: {},
            exportIncomeDifferenceDiag: false,
        };
    },

    methods: {
        //政策点击预览
        zcsclick(id) {
            this.$refs.boxref.zcsclick(id);
        },
        //选中格子
        forhover(table, colum, index) {
            this.$refs.boxref.forhover(table, colum, index);
        },
        //获取选中格子
        getchoosecellCode(table, colum, index) {
            if (this.$emptyandnull(table)) {
                this.choosecellCode = '';
                return false;
            }
            this.choosetable = table;
            this.chooseindex = index;
            this.choosecolum = colum;
            if(!table||!table||!colum){
                return
            }
            this.choosecellCode = this[table][index][colum].cellCode;
            if (this.toseeUpdate) {
                this.smtext = this[table][index][colum]['map'] ? this[table][index][colum]['map']['desc'] : '';
                this.zcdata = this[table][index][colum]['map'] ? this[table][index][colum]['map']['zcs'] : [];
            } else {
                this.smtext = this[table][index][colum]['updateDesc'] || '';
            }
        },
        //更正说明
        forgengzheng(table, colum, index, smtext) {
            this[table][index][colum]['updateDesc'] = smtext;
        },
        //更正政策和说明
        forxzsm(table, colum, index, smtext, zcdata) {
            this[table][index][colum]['map'] = {
                desc: '',
                zcs: []
            };
            this[table][index][colum]['map']['desc'] = smtext;
            this[table][index][colum]['map']['zcs'] = zcdata;
        },
        //点击全部范围
        refreshhover() {
            this.$nextTick(() => {
                this.$refs.boxref.refreshhover();
            });
        },
        getShuibDetailList() {
            getShuibDetailList({
                shuizId: this.params.shuizId,
                id: this.params.shuibId
            }).then((res) => {
                if (res.data.code == 1) {
                    this.treedata = res.data.data;
                    if (this.treedata[0]) {
                        this.getchoosetitleindex(this.treedata[0]);
                    }
                    this.querycell();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        manuscriptqueryReportStep() {
            manuscriptqueryReportStep({
                id: this.params.id,
                sbbm: this.params.sbbm
            }).then((res) => {
                if (res.data.code == 1) {
                    this.statedata = res.data.data.statusHistory;
                    this.treedata = res.data.data.detail;
                    if (this.treedata[0]) {
                        this.getchoosetitleindex(this.treedata[0]);
                    }
                    this.querycell();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        getchoosetitleindex(item) {
            this.choosetitleindex = item.shuibNameCode;
        },
        //表格隐藏显示和返回
        forback() {
            if (this.Changed > 0) {
                this.$showConfirm({
                    message: '是否不保存当前修改?',
                    title: '您还未保存'
                }).then((res) => {
                    if (res == 'confirm') {
                        this.$emit('forback', true);
                    } else {
                        //取消
                    }
                });
            } else {
                this.$emit('forback', true);
            }
        },
        changestate(e) {
            this.treestate = e;
        },
        //传给后端值处理
        filternums(data, filterlist) {
          var newlist = [];
          filterlist.forEach((ytem) => {
            let newval = data.map((item) => {
              if (
                  item[ytem] != undefined &&
                  item[ytem] != 'undefined' &&
                  this.$notemptyandnull(item[ytem]) &&
                  item[ytem].cellVal != '合计'
              ) {
                if ((item[ytem].cellCode === "sdsA_1_0c_1" || item[ytem].cellCode === "sdsA_1_0d_1" || item[ytem].cellCode === "sdsA_1_0e_1" || item[ytem].cellCode === "sdsA_1_0g_1" || item[ytem].cellCode === "sdsA_1_0h_1"
                    || item[ytem].cellCode === "sdsA_1_0c_2" || item[ytem].cellCode === "sdsA_1_0d_2" || item[ytem].cellCode === "sdsA_1_0e_2"
                    || item[ytem].cellCode === "sdsA_1_0e_3" || item[ytem].cellCode === "sdsA_1_0f_1" || item[ytem].cellCode === "sdsA_1_0f_2"
                    || item[ytem].cellCode === "sdsA_1_0g_2" || item[ytem].cellCode === "sdsA_1_0h_2") && item[ytem].cellVal) {
                        console.log(item[ytem].cellCode+'---'+item[ytem].cellVal)
                  item[ytem].cellType = "1";
                }
                if (item[ytem].cellCode === "sdsA_1_0g_2") {
                  let valArr = [];
                  if (item[ytem].cellVal1 === "Y") {
                    valArr.push("发生了自营出口业务");
                  }
                  if (item[ytem].cellVal2 === "Y") {
                    valArr.push("发生了委托出口业务");
                  }
                  if (item[ytem].cellVal3 === "Y") {
                    valArr.push("承担了代理出口业务");
                  }
                  item[ytem].cellVal = valArr.join("/");
                }
                return item[ytem];
              } else {
                return 'x';
              }
            });
            newlist = [...newlist, ...newval].filter((gtem) => gtem !== 'x');
          });
          return newlist;
        },
        refreshtableDataI() {
            this.tableDataI.forEach((item, index) => {
                this.IHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
            this.tableDatasvii.forEach((item, index) => {
                this.IHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
            this.tableDatasvi.forEach((item, index) => {
                this.IHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
            this.tableDatasv.forEach((item, index) => {
                this.IHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
            this.tableDatas.forEach((item, index) => {
                this.IHead.forEach((gtem) => {
                  if (item[gtem] && item[gtem].cellCode === "sdsA_1_0g_2") {
                    item[gtem].cellVal1 = "N";
                    item[gtem].cellVal2 = "N";
                    item[gtem].cellVal3 = "N";
                    item[gtem].cellVal = '';
                  } else if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                    item[gtem].cellVal = '';
                    item[gtem].cellType = 0;
                  }
                });
            });
        },
        refreshtableDataII() {
            this.tableDataII.forEach((item, index) => {
                this.IIHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
        },
        refreshtableDataIII() {
            this.tableDataIII.forEach((item, index) => {
                this.IIIHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
            this.tableDatavx.forEach((item, index) => {
                this.IIIHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = 0;
                    }
                });
            });
        },
        commanddcrefresh(e) {
            this.Changed++;
            if (e == 'all') {
                Object.keys(this.headobj).map((key) => (this.headobj[key] = ''));
                this.refreshtableDataI();
                this.refreshtableDataIII();
                this.refreshtableDataII();
            }
        },
        //所有表格渲染
        querycell(index) {
            if (this.type == 'update') {
                querycell({
                    companyNo: this.params.companyNo, // 公司编号
                    id: this.params.id, //报表id
                    shuibId: this.params.shuibId, //税种id
                    sbbm: this.params.sbbm
                }).then((res) => {
                    let dataarr = res.data.data;
                    this.gettable(dataarr);
                });
            }
            if (this.type == 'tosee') {
                if (this.seeNow) {
                    querycell({
                        companyNo: this.params.companyNo, // 公司编号
                        id: this.params.id, //报表id
                        shuibId: this.params.shuibId, //税种id
                        sbbm: this.params.sbbm
                    }).then((res) => {
                        let dataarr = res.data.data;
                        this.gettable(dataarr);
                    });
                    return false;
                }
                if (this.toseeUpdate) {
                    querytemplatecell({
                        shuibId: this.params.shuibId,
                        id: this.params.id
                    }).then((res) => {
                        let dataarr = res.data.data;
                        this.gettable(dataarr);
                    });
                } else {
                    reportquerytrack({
                        companyNo: this.params.companyNo, // 公司编号
                        id: this.params.id, //报表id
                        shuibId: this.params.shuibId, //税种id
                        sbbm: this.params.sbbm,
                        trackId: this.params.trackId
                    }).then((res) => {
                        let dataarr = res.data.data;
                        this.gettable(dataarr);
                    });
                }
            }
        },

        gettable(dataarr) {
            this.headobj = dataarr.head;
            this.delCellsI = [];
            this.delCellsIII = [];
            //I
            //资产加速折旧、摊销(扣除)优惠明细表
            if (dataarr.sdsA_2) {
                var newtableDataII = dataarr.sdsA_2;
                var realtableDataII = getdataII().tableData;
                realtableDataII.forEach((item, index) => {
                    if (newtableDataII[index]) {
                        this.IIHead.forEach((gtem) => {
                            item[gtem] = newtableDataII[index][gtem];
                        });
                    }
                });
                this.tableDataII = realtableDataII;
            }
            //主表
            var newtableDataI = dataarr.sdsA_1.filter((item, index) => index < 2);
            var realtableDataI = getdataI().tableData;
            realtableDataI.forEach((item, index) => {
                if (newtableDataI[index]) {
                    this.IHead.forEach((gtem) => {
                        item[gtem] = newtableDataI[index][gtem];
                    });
                }
            });
            this.tableDataI = realtableDataI;

          var newtableDatas = dataarr.sdsA_1.filter((item, index) => index > 1 && index < 8);
          var oldTableDatas = getdataI().tableDatas;
          var realtableDatas = JSON.parse(JSON.stringify(newtableDatas));
          realtableDatas.forEach((item, index) => {
            if (newtableDatas[index]) {
              this.IHead.forEach((gtem) => {
                if (newtableDatas[index][gtem]) {
                  if (newtableDatas[index][gtem].cellCode === "sdsA_1_0c_2" || newtableDatas[index][gtem].cellCode === "sdsA_1_0d_2"
                      || newtableDatas[index][gtem].cellCode === "sdsA_1_0g_2" || newtableDatas[index][gtem].cellCode === "sdsA_1_0h_2") {
                    if (newtableDatas[index][gtem].cellCode === "sdsA_1_0g_2") {
                      if (newtableDatas[index][gtem].cellVal) {
                        let arr = newtableDatas[index][gtem].cellVal.split("/");
                        for (let i = 0; i < arr.length; i++) {
                          if (arr[i] === "发生了自营出口业务") {
                            newtableDatas[index][gtem].cellVal1 = "Y";
                          } else if (arr[i] === "发生了委托出口业务") {
                            newtableDatas[index][gtem].cellVal2 = "Y";
                          } else if (arr[i] === "承担了代理出口业务") {
                            newtableDatas[index][gtem].cellVal3 = "Y";
                          }
                        }
                        if (newtableDatas[index][gtem].cellVal1 !== "Y") {
                          newtableDatas[index][gtem].cellVal1 = "N";
                        }
                        if (newtableDatas[index][gtem].cellVal2 !== "Y") {
                          newtableDatas[index][gtem].cellVal2 = "N";
                        }
                        if (newtableDatas[index][gtem].cellVal3 !== "Y") {
                          newtableDatas[index][gtem].cellVal3 = "N";
                        }
                      } else {
                        newtableDatas[index][gtem].cellVal1 = "N";
                        newtableDatas[index][gtem].cellVal2 = "N";
                        newtableDatas[index][gtem].cellVal3 = "N";
                      }
                    }
                    item['sdsA_1_x_3'] = newtableDatas[index]['sdsA_1_x_2'];
                  } else if (newtableDatas[index][gtem].cellCode === "sdsA_1_0f_1") {
                    item['sdsA_1_x_2'] = newtableDatas[index]['sdsA_1_x_1'];
                  } else if (newtableDatas[index][gtem].cellCode === "sdsA_1_0f_2") {
                    item['sdsA_1_x_3'] = newtableDatas[index]['sdsA_1_x_2'];
                  } else {
                    item[gtem] = newtableDatas[index][gtem];
                  }
                }
              });
              oldTableDatas.forEach((ytem) => {
                if (ytem.hanh == newtableDatas[index].hanh) {
                  item['code'] = ytem['code'];
                  item['title'] = ytem['title'];
                  item['title2'] = ytem['title2'];
                }
              });
            }
          });
          realtableDatas[3].sdsA_1_x_1.cellVal = realtableDatas[2].sdsA_1_x_1.cellVal;
          this.tableDatas = realtableDatas;
            var newtableDatasv = dataarr.sdsA_1.filter((item, index) => parseFloat(item.hanh) >= 1 && parseFloat(item.hanh) < 33);
            var oldsv = getdataI().tableDatasv;
            var realtableDatasv = newtableDatasv;
            realtableDatasv.forEach((item, index) => {
                if (newtableDatasv[index]) {
                  this.IHead.forEach((gtem) => {
                    if (typeof newtableDatasv[index][gtem] != 'undefined' && typeof newtableDatasv[index][gtem] != undefined) {
                      if ((parseFloat(newtableDatasv[index].hanh) > 22 && parseFloat(newtableDatasv[index].hanh) < 23)
                          || (parseFloat(newtableDatasv[index].hanh) > 23 && parseFloat(newtableDatasv[index].hanh) < 24)
                          || (parseFloat(newtableDatasv[index].hanh) > 28 && parseFloat(newtableDatasv[index].hanh) < 29)
                          || (parseFloat(newtableDatasv[index].hanh) > 29 && parseFloat(newtableDatasv[index].hanh) < 30)) {
                        item['sdsA_1_x_1'] = newtableDatasv[index]['sdsA_1_x_1'];
                        item['sdsA_1_x_2'] = newtableDatasv[index]['sdsA_1_x_2'];
                      } else {
                        item['sdsA_1_x_2'] = newtableDatasv[index]['sdsA_1_x_1'];
                        if (newtableDatasv[index].hanh === "26") {
                          item['sdsA_1_x_2'].cellVal = '0.25';
                        }
                      }
                    }
                  });
                    oldsv.forEach((ytem) => {
                        if (ytem.groud == newtableDatasv[index].hanh) {
                            item['groud'] = ytem['groud'];
                            item['title'] = ytem['title'];
                            item['disabledsdsA_1_x_1'] = ytem['disabledsdsA_1_x_1'];
                        }
                    });
                }
            });
            this.tableDatasv = realtableDatasv;
            this.changeqiylx(this.headobj);
          var newtableDatasvi = dataarr.sdsA_1.filter((item, index) => parseFloat(item.hanh) >= 33 && parseFloat(item.hanh) <= 38);
          var realtableDatasvi = getdataI().tableDatasvi;
          realtableDatasvi.forEach((item, index) => {
            if (newtableDatasvi[index]) {
              this.IHead.forEach((gtem) => {
                if (typeof newtableDatasvi[index][gtem] != 'undefined' && typeof newtableDatasvi[index][gtem] != undefined) {
                  item['sdsA_1_x_3'] = newtableDatasvi[index]['sdsA_1_x_1'];
                }
              });
            }
          });
          this.tableDatasvi = realtableDatasvi;
          var newtableDatasvii = dataarr.sdsA_1.filter((item, index) => parseFloat(item.hanh) > 38);
          var realtableDatasvii = getdataI().tableDatasvii;
          realtableDatasvii.forEach((item, index) => {
            if (newtableDatasvii[index]) {
              this.IHead.forEach((gtem) => {
                if (typeof newtableDatasvii[index][gtem] != 'undefined' && typeof newtableDatasvii[index][gtem] != undefined) {
                  if (newtableDatasvii[index].hanh === "39.1") {
                    item['sdsA_1_x_1'] = newtableDatasvii[index]['sdsA_1_x_1'];
                    item['sdsA_1_x_2'] = newtableDatasvii[index]['sdsA_1_x_2'];
                    item['sdsA_1_x_3'] = newtableDatasvii[index]['sdsA_1_x_3'];
                  } else {
                    item['sdsA_1_x_3'] = newtableDatasvii[index]['sdsA_1_x_1'];
                  }
                }
              });
            }
          });
            this.tableDatasvii = realtableDatasvii;
            // //III
            var newtableDataIII = dataarr.sdsA_3.filter((item, index) => index == 0);
            var realtableDataIII = getdataIII().tableData;
            realtableDataIII.forEach((item, index) => {
                if (newtableDataI[index]) {
                    this.IIIHead.forEach((gtem) => {
                        item[gtem] = newtableDataIII[index][gtem];
                    });
                }
            });
            this.tableDataIII = realtableDataIII;
            var newtableDatavx = dataarr.sdsA_3.filter((item, index) => index > 0);
            var realtableDatavx = newtableDatavx;
            realtableDatavx.forEach((item, index) => {
                if (newtableDatavx[index]) {
                    this.IIIHead.forEach((gtem) => {
                        if (index === realtableDatavx.length - 1) {
                            item.sdsA_3_x_1 = {
                                cellCode: '',
                                cellVal: '分支机构合计'
                            };
                            item.sdsA_3_x_2 = {
                                cellCode: '',
                                cellVal: '分支机构合计'
                            };
                            item.sdsA_3_x_3 = {
                              cellCode: '',
                              cellVal: '分支机构合计'
                            };
                            item.sdsA_3_x_4 = newtableDatavx[index].sdsA_3_x_4;
                            item.sdsA_3_x_5 = newtableDatavx[index].sdsA_3_x_5;
                            item.sdsA_3_x_6 = newtableDatavx[index].sdsA_3_x_6;
                            item.sdsA_3_x_7 = newtableDatavx[index].sdsA_3_x_7;
                            item.sdsA_3_x_8 = newtableDatavx[index].sdsA_3_x_8;
                            item.sdsA_3_x_9 = newtableDatavx[index].sdsA_3_x_9;
                            item.sdsA_3_x_10 = newtableDatavx[index].sdsA_3_x_10;
                            item.sdsA_3_x_11 = newtableDatavx[index].sdsA_3_x_11;
                            item.sdsA_3_x_12 = newtableDatavx[index].sdsA_3_x_12;
                            item.sdsA_3_x_13 = newtableDatavx[index].sdsA_3_x_13;
                            item.sdsA_3_x_14 = newtableDatavx[index].sdsA_3_x_14;
                        } else {
                            item[gtem] = newtableDatavx[index][gtem];
                        }
                    });
                }
            });
            this.tableDatavx = realtableDatavx;
            // this.tableDatavx.map(item => {
            // 	if (item.sdsA_3_x_6) {
            // 		item.sdsA_3_x_6.cellVal = item.sdsA_3_x_6.cellVal == '' ? 0 : this.$numMulti(item.sdsA_3_x_6.cellVal, 100);
            // 	}
            // });

            // this.tableDataII = getdataII().tableData
            // //III
            // this.tableDataIII = getdataIII().tableData
            // this.tableDatavx = getdataIII().tableDatavx
            // //VI
            // this.tableDataVI = getdataVI().tableData
            // //V
            // this.tableDataV = getdataV().tableData

            // var newtabledataI = dataarr.zzs_1
            // var realtableDataI = getdataI().tableData
            // realtableDataI.forEach((item, index) => {
            // 	if (newtabledataI[index]) {
            // 		this.IHead.forEach(gtem => {
            // 			item[gtem] = newtabledataI[index][gtem]
            // 		})
            // 	}
            // })

            // //附表二
            // var newtabledataII = dataarr.zzs_2
            // var newtabledataII_I = newtabledataII.filter((item, index) => index < 13)
            // var realtableDataII_I = getdataII().tableDataI
            // realtableDataII_I.forEach((item, index) => {
            // 	if (newtabledataII_I[index]) {
            // 		this.IIHead.forEach(gtem => {
            // 			item[gtem] = newtabledataII_I[index][gtem]
            // 		})
            // 	}
            // })

            // this.tableDataII_I = realtableDataII_I
            // var newtabledataII_II = newtabledataII.filter((item, index) => index > 12 & index < 25)
            // var realtableDataII_II = getdataII().tableDataII
            // realtableDataII_II.forEach((item, index) => {
            // 	if (newtabledataII_II[index]) {
            // 		item.zzs_2_x_3 = newtabledataII_II[index].zzs_2_x_1
            // 	}
            // })
            // this.tableDataII_II = realtableDataII_II
            // var newtabledataII_III = newtabledataII.filter((item, index) => index > 24 & index < 36)
            // var realtableDataII_III = getdataII().tableDataIII
            // realtableDataII_III.forEach((item, index) => {
            // 	if (newtabledataII_III[index]) {
            // 		this.IIHead.forEach(gtem => {
            // 			item[gtem] = newtabledataII_III[index][gtem]
            // 		})
            // 	}
            // })
        },
        IdelCellsCode(e) {
            this.delCellsI = [...this.filternums(e, this.IHead)];
        },
        IIIdelCellsCode(e) {
            this.delCellsIII = [...this.filternums(e, this.IIIHead)];
        },
        checkerror() {
            if (this.headobj.qiylx === "2") {
              return true;
            }
            let arr = [];
            if (this.headobj.xiaoxwlqy == '' || this.headobj.xiaoxwlqy == null || this.headobj.xiaoxwlqy == '0') {
                arr.push('请选择是否是小型微利企业');
            }
            if (this.headobj.guojxzhjzhy == '' || this.headobj.guojxzhjzhy == null || this.headobj.guojxzhjzhy == '0') {
                arr.push('请选择是否是国家限制或禁止行业');
            }
            if (!this.tableDatas[5].sdsA_1_x_3.cellVal) {
              arr.push('企业所得税主表资产损失必填');
            }
            if (this.gettableval('sdsA_1_1_1', 'tableDatasv') || this.gettableval('sdsA_1_2_1', 'tableDatasv') || this.gettableval('sdsA_1_18_1', 'tableDatasv')) {
              if (this.tableDatas[2].sdsA_1_x_1.cellVal !== "Y") {
                arr.push('企业所得税主表第1栏/第2栏/第18栏有值时，职工薪酬必填');
              }
            }
            // 若sdsA_1_18_1 + sdsA_1_19_1 - sdsA_1_20_1 - sdsA_1_21_1 - sdsA_1_22_1 ≤ 0，不填报；
            if ((this.gettableval('sdsA_1_18_1', 'tableDatasv') + this.gettableval('sdsA_1_19_1', 'tableDatasv')
                - this.gettableval('sdsA_1_20_1', 'tableDatasv') - this.gettableval('sdsA_1_21_1', 'tableDatasv')
                - this.gettableval('sdsA_1_22_1', 'tableDatasv') <= 0) && this.gettableval('sdsA_1_23_1', 'tableDatasv') != 0) {
              arr.push('企业所得税主表第18栏+第19栏-第20栏-第21栏-第22栏 <=0，则第23栏不填报');
            }
            if (this.gettableval('sdsA_1_27_1', 'tableDatasv') < 0) {
              arr.push('企业所得税主表第25栏 × 第26栏必须 ≥ 0');
            }
            if (this.gettableval('sdsA_1_28_1', 'tableDatasv') < 0
                || this.gettableval('sdsA_1_28_1', 'tableDatasv') > this.gettableval('sdsA_1_27_1', 'tableDatasv')) {
              arr.push('企业所得税主表第28栏必须 ≥ 0，且≤ 第27栏');
            }
            if (this.gettableval('sdsA_1_29_1', 'tableDatasv') < 0
                || this.gettableval('sdsA_1_29_1', 'tableDatasv') > this.gettableval('sdsA_1_27_1', 'tableDatasv') - this.gettableval('sdsA_1_28_1', 'tableDatasv')) {
              arr.push('企业所得税主表第29栏必须 ≥ 0，且≤ 第27栏 - 第28栏');
            }
            // TODO sdsA_1_31_1必须≥上期填报金额

            // // sdsA_1_9_1不等于YWKM_cwbbyzx_1_11_1，提示“财务报表读取的投资收益金额【XXX】与您填报的9.1+9.2合计金额【XXX】不一致，请核实。”
            // if (Number(this.gettableval('sdsA_1_9_1', 'tableDatasv')) !== Number(this.checkData.tzsy)) {
            //   arr.push('财务报表读取的投资收益金额【'+this.checkData.tzsy+'】与您填报的第9栏金额【'+this.gettableval('sdsA_1_9_1', 'tableDatasv')+'】不一致，请核实。');
            // }
            // // sdsA_1_15_1不等于YWKM_cwbbyzx_1_19_1保存报错“财务报表取值的营业利润XXXX元，不满足本行=本表的(1行-2行-3行-4行-5行-6行-7行+8行+9行+10行+11行+12行+13行+14行)，请核实。”
            // if (Number(this.gettableval('sdsA_1_15_1', 'tableDatasv')) !== Number(this.checkData.yylr)) {
            //   arr.push('财务报表取值的营业利润'+this.checkData.yylr+'元，不满足等于本表第15栏，请核实。');
            // }
            // // sdsA_1_18_1 小于上一期利润总额提示“填报的金额小于最近一期申报的金额【XXX】，请确认无误。”
            // if (Number(this.gettableval('sdsA_1_18_1', 'tableDatasv')) < Number(this.checkData.sqlrze)) {
            //   arr.push('第18栏填写的金额小于最近一期申报的金额【'+this.checkData.sqlrze+'】，请核实。');
            // }
            // // sdsA_1_18_1 不等于【YWKM_cwbbyzx_1_22_1】，提示“申报的第18行[利润总额本年累计金额【XXX】不一致，请核实。”
            // if (Number(this.gettableval('sdsA_1_18_1', 'tableDatasv')) !== Number(this.checkData.bqlrze)) {
            //   arr.push('第18栏填写的金额与利润总额本年累计金额【'+this.checkData.bqlrze+'】不一致，请核实。');
            // }

            if (arr.length > 0) {
                this.errarr = arr;
                this.errdiag = true;
                return false;
            } else {
                return true;
            }
        },
        // 保存底稿生成数据
        forsave() {
            let status = this.checkerror();
            if (!status) {
                return;
            }
            const newarr = [
                ...this.filternums(this.tableDataI, this.IHead),
                ...this.filternums(this.tableDatas, this.IHead),
                ...this.filternums(this.tableDatasv, this.IHead),
                ...this.filternums(this.tableDatasvi, this.IHead),
                ...this.filternums(this.tableDatasvii, this.IHead),
                ...this.filternums(this.tableDataIII, this.IIIHead),
                ...this.filternums(this.tableDatavx, this.IIIHead),
                ...this.filternums(this.tableDataII, this.IIHead)
            ];
            let params = {
                cells: newarr,
                checkFlag: true,
                companyNo: this.params.companyNo,
                id: this.params.id,
                sbbm: this.params.sbbm,
                head: this.headobj,
                delCells: [...this.delCellsI, ...this.delCellsIII]
            };
            // 保存底稿校验（若与配置公式的对应格子值不一致，需要提示）
            let scDiGaoDto = {
              companys: [{
                companyNo: this.params.companyNo,
                id: this.params.id,
                sbbm: this.params.sbbm,
                shuibId: this.params.shuibId,
                templateId: this.params.templateId
              }],
              suosq: this.suosq
            };
            manuscriptSaveVerified({saveTaxReportCellsDto: params, scDiGaoDto: scDiGaoDto}).then((res) => {
              if (res.data.code === "1" && res.data.data.length > 0) {
                this.$showConfirm({
                  message: res.data.data + "的保存结果与一键生成底稿的结果不一致，是否继续保存！",
                }).then((res) => {
                  if (res === "confirm") {
                    writesave(params).then((res) => {
                      if (res.data.code == 1) {
                        this.Changed = 0;
                        this.querycell();
                        this.$message.success(res.data.msg);
                        this.financialReportHint();
                      } else {
                        this.$message.error(res.data.msg);
                      }
                    });
                  }
                });
              } else {
                writesave(params).then((res) => {
                  if (res.data.code == 1) {
                    this.Changed = 0;
                    this.querycell();
                    this.$message.success(res.data.msg);
                    this.financialReportHint();
                  } else {
                    this.$message.error(res.data.msg);
                  }
                });
              }
            });
        },
        financialReportHint() {
          // 企业所得税保存底稿时，判断财报是否已申报，若未申报则提示(对应公司属期存在财务报表的时候才去判断是否已申报（申报、缴款 成功）)
          financialReportHint({sdsReportId: this.params.id}).then((res) => {
            if (res.data.code === 1) {
              if (res.data.data === "1") {
                this.$showConfirm({
                  message: '当前属期存在未申报的财务报表！',
                  title: '提示'
                }).then(res => {

                });
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
        },
        // 银行家舍入法
        bankersRound(number, decimalPlaces = 0) {
          if (isNaN(number)) return NaN;

          const factor = Math.pow(10, decimalPlaces);
          const isNegative = number < 0;
          const absNumber = Math.abs(number);
          const scaled = absNumber * factor;

          const integerPart = Math.trunc(scaled);
          const fractionalPart = scaled - integerPart;

          let result;

          if (fractionalPart < 0.5 - 1e-12) {
            result = integerPart;
          } else if (fractionalPart > 0.5 + 1e-12) {
            result = integerPart + 1;
          } else {
            // 正好在中间，使用银行家舍入
            result = (integerPart % 2 === 0) ? integerPart : integerPart + 1;
          }
          return (isNegative ? -result : result) / factor;
        },
        getsdsA_1_28__2(e) {
          let code = e.cellCode.substring(0, e.cellCode.length - 1) + "2";
          if (e.cellVal === '符合条件的小型微利企业减免企业所得税') {
            if (this.gettableval('sdsA_1_25_1', 'tableDatasv') > 0) {
              this.changetableval(code, 'tableDatasv', this.gettableval('sdsA_1_25_1', 'tableDatasv') * 0.25 * 0.8);
            } else {
              this.changetableval(code, 'tableDatasv', 0);
            }
          } else if (e.cellVal === '国家需要重点扶持的高新技术企业减按15%的税率征收企业所得税') {
            if (this.gettableval('sdsA_1_25_1', 'tableDatasv') > 0) {
              this.changetableval(code, 'tableDatasv', this.bankersRound(this.multiply(this.gettableval('sdsA_1_25_1', 'tableDatasv'), 0.1), 2));
            } else {
              this.changetableval(code, 'tableDatasv', 0);
            }
          } else if (e.cellVal === '国家鼓励的软件企业减免企业所得税' && this.gettableval('sdsA_1_0d_1', 'tableDatas') === 'Y') {
            this.changetableval(code, 'tableDatasv', this.gettableval('sdsA_1_27_1','tableDatasv'))
          } else {
            this.changetableval(code, 'tableDatasv', 0);
          }
        },
        //乘法
        multiply(arg1,arg2){
          if (arg1 == undefined || arg1 == "NaN") {
            arg1 = 0
          }
          if (arg2 == undefined || arg2 == "NaN") {
            arg2 = 0
          }
          var m=0,s1=arg1.toString().replaceAll(",",""),s2=arg2.toString().replaceAll(",","");
          try{m+=s1.split(".")[1].length}catch(e){}
          try{m+=s2.split(".")[1].length}catch(e){}
          return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
        } ,
        inputblur(e) {
            this.Changed++;
            // 列号
            let columnNumber = e.cellCode.substring(e.cellCode.lastIndexOf('_') + 1);
            // 行号
            let lineNumber = e.cellCode.substring(7, e.cellCode.lastIndexOf('_'));
            let cellval = e.cellVal == '' ? '0.00' : e.cellVal;
            if (e.cellCode.substring(7, 10) !== '28.' && e.cellCode !== "sdsA_1_39.1_2") {
              try {
                if (
                    parseFloat(e.cellVal).toFixed(2) !=
                    parseFloat(this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal']).toFixed(2) &&
                    this[this.choosetable][this.chooseindex][this.choosecolum]['cellCode'] == e.cellCode
                ) {
                  this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
                }
              } catch (e) {
              }
			      }
            if (((e.cellCode.substring(0, 10) != 'sdsA_1_22.' || e.cellCode.substring(0, 10) != 'sdsA_1_28.'
                || e.cellCode.substring(0, 10) != 'sdsA_1_23.' || e.cellCode.substring(0, 10) != 'sdsA_1_29.')
                && e.cellCode.substring(e.cellCode.lastIndexOf('_')+1) == '1')
                || e.cellCode == 'sdsA_1_39.1_2'
            ) {
                if (e.cellVal != 0 && e.cellVal != '' && e.cellVal != null) {
                    e.cellType = '1';
                }
            }

            //主表
            // 优惠及附报事项有关信息
            if (
                e.cellCode == 'sdsA_1_0a_1' ||
                e.cellCode == 'sdsA_1_0a_2' ||
                e.cellCode == 'sdsA_1_0a_3' ||
                e.cellCode == 'sdsA_1_0a_4' ||
                e.cellCode == 'sdsA_1_0a_5' ||
                e.cellCode == 'sdsA_1_0a_6' ||
                e.cellCode == 'sdsA_1_0a_7' ||
                e.cellCode == 'sdsA_1_0a_8'
            ) {
              let countsdsA_1_0a_1 = 0;
              if (this.gettableval('sdsA_1_0a_1', 'tableDataI') > 0 || this.gettableval('sdsA_1_0a_2', 'tableDataI') > 0) {
                countsdsA_1_0a_1++;
              }
              if (this.gettableval('sdsA_1_0a_3', 'tableDataI') > 0 || this.gettableval('sdsA_1_0a_4', 'tableDataI') > 0) {
                countsdsA_1_0a_1++;
              }
              if (this.gettableval('sdsA_1_0a_5', 'tableDataI') > 0 || this.gettableval('sdsA_1_0a_6', 'tableDataI') > 0) {
                countsdsA_1_0a_1++;
              }
              if (this.gettableval('sdsA_1_0a_7', 'tableDataI') > 0 || this.gettableval('sdsA_1_0a_8', 'tableDataI') > 0) {
                countsdsA_1_0a_1++;
              }
              countsdsA_1_0a_1 = countsdsA_1_0a_1 == 0 ? 1 : countsdsA_1_0a_1;
              this.changetableval(
                  'sdsA_1_0a_9',
                  'tableDataI',
                  Number(
                      (
                          ((this.gettableval('sdsA_1_0a_1', 'tableDataI') + this.gettableval('sdsA_1_0a_2', 'tableDataI')) / 2 +
                              (this.gettableval('sdsA_1_0a_3', 'tableDataI') + this.gettableval('sdsA_1_0a_4', 'tableDataI')) / 2 +
                              (this.gettableval('sdsA_1_0a_5', 'tableDataI') + this.gettableval('sdsA_1_0a_6', 'tableDataI')) / 2 +
                              (this.gettableval('sdsA_1_0a_7', 'tableDataI') + this.gettableval('sdsA_1_0a_8', 'tableDataI')) / 2) /
                          countsdsA_1_0a_1
                      ).toFixed(0)
                  )
              );
            }
            if (
                e.cellCode == 'sdsA_1_0b_1' ||
                e.cellCode == 'sdsA_1_0b_2' ||
                e.cellCode == 'sdsA_1_0b_3' ||
                e.cellCode == 'sdsA_1_0b_4' ||
                e.cellCode == 'sdsA_1_0b_5' ||
                e.cellCode == 'sdsA_1_0b_6' ||
                e.cellCode == 'sdsA_1_0b_7' ||
                e.cellCode == 'sdsA_1_0b_8'
            ) {
              let countsdsA_1_0b_1 = 0;
              if (this.gettableval('sdsA_1_0b_1', 'tableDataI') > 0 || this.gettableval('sdsA_1_0b_2', 'tableDataI') > 0) {
                countsdsA_1_0b_1++;
              }
              if (this.gettableval('sdsA_1_0b_3', 'tableDataI') > 0 || this.gettableval('sdsA_1_0b_4', 'tableDataI') > 0) {
                countsdsA_1_0b_1++;
              }
              if (this.gettableval('sdsA_1_0b_5', 'tableDataI') > 0 || this.gettableval('sdsA_1_0b_6', 'tableDataI') > 0) {
                countsdsA_1_0b_1++;
              }
              if (this.gettableval('sdsA_1_0b_7', 'tableDataI') > 0 || this.gettableval('sdsA_1_0b_8', 'tableDataI') > 0) {
                countsdsA_1_0b_1++;
              }
              countsdsA_1_0b_1 = countsdsA_1_0b_1 == 0 ? 1 : countsdsA_1_0b_1;
              this.changetableval(
                  'sdsA_1_0b_9',
                  'tableDataI',
                  this.$calc.divide(
                      this.$calc.divide(
                          this.$calc.add(
                              this.gettableval('sdsA_1_0b_1', 'tableDataI'),
                              this.gettableval('sdsA_1_0b_2', 'tableDataI')
                          ),
                          2
                      ) +
                      this.$calc.divide(
                          this.$calc.add(
                              this.gettableval('sdsA_1_0b_3', 'tableDataI'),
                              this.gettableval('sdsA_1_0b_4', 'tableDataI')
                          ),
                          2
                      ) +
                      this.$calc.divide(
                          this.$calc.add(
                              this.gettableval('sdsA_1_0b_5', 'tableDataI'),
                              this.gettableval('sdsA_1_0b_6', 'tableDataI')
                          ),
                          2
                      ) +
                      this.$calc.divide(
                          this.$calc.add(
                              this.gettableval('sdsA_1_0b_7', 'tableDataI'),
                              this.gettableval('sdsA_1_0b_8', 'tableDataI')
                          ),
                          2
                      )
                      , countsdsA_1_0b_1)
              );
            }

            // 预缴税款计算
            if (e.cellCode.substring(0, 10) === 'sdsA_1_28.'
                && (e.cellVal === '符合条件的小型微利企业减免企业所得税' || e.cellVal === '国家需要重点扶持的高新技术企业减按15%的税率征收企业所得税' || e.cellVal === '国家鼓励的软件企业减免企业所得税')) {
              if (e.cellVal === '国家鼓励的软件企业减免企业所得税' && this.gettableval('sdsA_1_0d_1', 'tableDatas') === 'Y') {

              } else {
                if (e.cellVal !== '国家需要重点扶持的高新技术企业减按15%的税率征收企业所得税' && e.cellVal !== '符合条件的小型微利企业减免企业所得税') {
                  this.$message.error('您未选择 ：软件集成电路企业按新政策或原政策执行优惠（单选：原政策/新政策） 该政策将不生效');
                }
              }
              this.getsdsA_1_28__2(e);
            } else if (e.cellCode.substring(0, 10) === 'sdsA_1_28.' && (e.cellVal === '请选择' || e.cellVal === '' || e.cellVal === '')) {
                let code = e.cellCode.substring(0, e.cellCode.length - 1) + "2";
                this.changetableval(code, 'tableDatasv', 0);
            }
            if (e.cellCode === "sdsA_1_25_1" || e.cellCode === "sdsA_1_27_1") {
              this.getsdsA_1_28_1_2(e);
            }

            if (e.cellCode === "sdsA_1_9.1_1" || e.cellCode === "sdsA_1_9.2_1") {
              this.changetableval(
                  'sdsA_1_9_1',
                  'tableDatasv',
                  this.gettableval('sdsA_1_9.1_1', 'tableDatasv') +
                      this.gettableval('sdsA_1_9.2_1', 'tableDatasv')
              );
            }
            if (e.cellCode === "sdsA_1_1_1" || e.cellCode === "sdsA_1_2_1" || e.cellCode === "sdsA_1_3_1" || e.cellCode === "sdsA_1_4_1"
                || e.cellCode === "sdsA_1_5_1" || e.cellCode === "sdsA_1_6_1" || e.cellCode === "sdsA_1_7_1" || e.cellCode === "sdsA_1_8_1"
                || e.cellCode === "sdsA_1_9_1" || e.cellCode === "sdsA_1_10_1" || e.cellCode === "sdsA_1_11_1" || e.cellCode === "sdsA_1_12_1"
                || e.cellCode === "sdsA_1_13_1" || e.cellCode === "sdsA_1_14_1") {
              // 1行-2行-3行-4行-5行-6行-7行+8行+9行+10行+11行+12行+13行+14行
              this.changetableval(
                  'sdsA_1_15_1',
                  'tableDatasv',
                  this.gettableval('sdsA_1_1_1', 'tableDatasv') -
                  this.gettableval('sdsA_1_2_1', 'tableDatasv') -
                  this.gettableval('sdsA_1_3_1', 'tableDatasv') -
                  this.gettableval('sdsA_1_4_1', 'tableDatasv') -
                  this.gettableval('sdsA_1_5_1', 'tableDatasv') -
                  this.gettableval('sdsA_1_6_1', 'tableDatasv') -
                  this.gettableval('sdsA_1_7_1', 'tableDatasv') +
                  this.gettableval('sdsA_1_8_1', 'tableDatasv') +
                  this.gettableval('sdsA_1_9_1', 'tableDatasv') +
                  this.gettableval('sdsA_1_10_1', 'tableDatasv') +
                  this.gettableval('sdsA_1_11_1', 'tableDatasv') +
                  this.gettableval('sdsA_1_12_1', 'tableDatasv') +
                  this.gettableval('sdsA_1_13_1', 'tableDatasv') +
                  this.gettableval('sdsA_1_14_1', 'tableDatasv')
              );
            }
            if (e.cellCode === "sdsA_1_15_1" || e.cellCode === "sdsA_1_16_1" || e.cellCode === "sdsA_1_17_1") {
              this.changetableval(
                  'sdsA_1_18_1',
                  'tableDatasv',
                  this.gettableval('sdsA_1_15_1', 'tableDatasv') +
                  this.gettableval('sdsA_1_16_1', 'tableDatasv') -
                  this.gettableval('sdsA_1_17_1', 'tableDatasv')
              );
            }
            if (e.cellCode === "sdsA_2_3_5") {
              this.changetableval(
                  'sdsA_1_21_1',
                  'tableDatasv',
                  this.gettableval('sdsA_2_3_5', 'tableDataII')
              );
            }
            if (e.cellCode.substring(0, 6) === 'sdsA_1' && lineNumber > 22 && lineNumber < 23 && columnNumber === "2") {
              this.getsdsA_1_22_1();
            }
            if (e.cellCode === "sdsA_1_18_1" || e.cellCode === "sdsA_1_19_1" || e.cellCode === "sdsA_1_20_1"
                || e.cellCode === "sdsA_1_21_1" || e.cellCode === "sdsA_1_22_1"
                || (e.cellCode.substring(0, 6) === 'sdsA_1' && lineNumber > 23 && lineNumber < 24 && columnNumber === "2")) {
              // 若sdsA_1_18_1 + sdsA_1_19_1 - sdsA_1_20_1 - sdsA_1_21_1 - sdsA_1_22_1 ≤ 0，不填报；
              if (this.gettableval('sdsA_1_18_1', 'tableDatasv') + this.gettableval('sdsA_1_19_1', 'tableDatasv')
                  - this.gettableval('sdsA_1_20_1', 'tableDatasv') - this.gettableval('sdsA_1_21_1', 'tableDatasv')
                  - this.gettableval('sdsA_1_22_1', 'tableDatasv') <= 0) {
                this.changetableval(
                    'sdsA_1_23_1',
                    'tableDatasv',
                    0
                );
              } else {
                this.getsdsA_1_23_1();
              }
            }
            if (e.cellCode === "sdsA_1_18_1" || e.cellCode === "sdsA_1_19_1" || e.cellCode === "sdsA_1_20_1"
                || e.cellCode === "sdsA_1_21_1" || e.cellCode === "sdsA_1_22_1" || e.cellCode === "sdsA_1_23_1") {
              // 若 sdsA_1_18_1 + sdsA_1_19_1 - sdsA_1_20_1 - sdsA_1_21_1 - sdsA_1_22_1 - sdsA_1_23_1  <= 0,sdsA_1_24_1=0；
              if (this.gettableval('sdsA_1_18_1', 'tableDatasv') + this.gettableval('sdsA_1_19_1', 'tableDatasv')
                  - this.gettableval('sdsA_1_20_1', 'tableDatasv') - this.gettableval('sdsA_1_21_1', 'tableDatasv')
                  - this.gettableval('sdsA_1_22_1', 'tableDatasv') - this.gettableval('sdsA_1_23_1', 'tableDatasv') <= 0) {
                this.changetableval(
                    'sdsA_1_24_1',
                    'tableDatasv',
                    0
                );
              }
            }
            if (this.headobj.yujfs === "0") {
              if (e.cellCode === "sdsA_1_18_1" || e.cellCode === "sdsA_1_19_1" || e.cellCode === "sdsA_1_20_1"
                  || e.cellCode === "sdsA_1_21_1" || e.cellCode === "sdsA_1_22_1" || e.cellCode === "sdsA_1_23_1"
                  || e.cellCode === "sdsA_1_24_1"){
                // 若prepayMethod“按照实际利润额预缴”，sdsA_1_25_1=sdsA_1_18_1 + sdsA_1_19_1 - sdsA_1_20_1 - sdsA_1_21_1 - sdsA_1_22_1 - sdsA_1_23_1 - sdsA_1_24_1
                this.changetableval(
                    'sdsA_1_25_1',
                    'tableDatasv',
                    this.gettableval('sdsA_1_18_1', 'tableDatasv') +
                    this.gettableval('sdsA_1_19_1', 'tableDatasv') -
                    this.gettableval('sdsA_1_20_1', 'tableDatasv') -
                    this.gettableval('sdsA_1_21_1', 'tableDatasv') -
                    this.gettableval('sdsA_1_22_1', 'tableDatasv') -
                    this.gettableval('sdsA_1_23_1', 'tableDatasv') -
                    this.gettableval('sdsA_1_24_1', 'tableDatasv')
                );
              } else if (e.cellCode === "sdsA_1_27_1" || e.cellCode === "sdsA_1_28_1" || e.cellCode === "sdsA_1_29_1"
                  || e.cellCode === "sdsA_1_30_1" || e.cellCode === "sdsA_1_31_1") {
                // 若prepayMethod“按照实际利润额预缴”，sdsA_1_32_1=sdsA_1_27_1-sdsA_1_28_1-sdsA_1_29_1-sdsA_1_30_1-sdsA_1_31_1；如果（sdsA_1_27_1-sdsA_1_28_1-sdsA_1_29_1-sdsA_1_30_1-sdsA_1_31_1）< 0 ，本格=0；
                let val = this.gettableval('sdsA_1_27_1', 'tableDatasv') -
                    this.gettableval('sdsA_1_28_1', 'tableDatasv') -
                    this.gettableval('sdsA_1_29_1', 'tableDatasv') -
                    this.gettableval('sdsA_1_30_1', 'tableDatasv') -
                    this.gettableval('sdsA_1_31_1', 'tableDatasv');
                if (val < 0) {
                  val = 0;
                }
                this.changetableval(
                    'sdsA_1_32_1',
                    'tableDatasv',
                    val
                );
              }
            } else if (this.headobj.yujfs === "3") {
              if (e.cellCode === "sdsA_1_27_1") {
                // 若prepayMethod“按照税务机关确定的其他方法预缴”，sdsA_1_32_1= sdsA_1_27_1
                this.changetableval(
                    'sdsA_1_32_1',
                    'tableDatasv',
                    this.gettableval('sdsA_1_27_1', 'tableDatasv')
                );
              }
            }
            if (e.cellCode === "sdsA_1_25_1" || e.cellCode === "sdsA_1_26_1") {
              let val = this.gettableval('sdsA_1_25_1', 'tableDatasv') * this.gettableval('sdsA_1_26_1', 'tableDatasv');
              if (val < 0) {
                val = 0;
              }
              this.changetableval(
                  'sdsA_1_27_1',
                  'tableDatasv',
                  val
              );
              this.getsdsA_1_28_1_2(e)
            }
            if (e.cellCode.substring(0, 6) === 'sdsA_1' && lineNumber > 28 && lineNumber < 29 && columnNumber === "2") {
              this.getsdsA_1_28_1();
            }
            if (e.cellCode.substring(0, 6) === 'sdsA_1' && lineNumber > 29 && lineNumber < 30 && columnNumber === "2") {
              this.getsdsA_1_29_1();
            }
            if (e.cellCode === "sdsA_3_0a_2") {
              this.changetableval(
                  'sdsA_1_31_1',
                  'tableDatasv',
                  this.gettableval('sdsA_3_0a_2', 'tableDataIII')
              );
            }
            if (e.cellCode === "sdsA_3_1_11") {
              this.changetableval(
                  'sdsA_1_36_1',
                  'tableDatasv',
                  this.gettableval('sdsA_3_1_11', 'tableDataIII')
              );
            }
            // 汇总纳税企业总分机构税款计算
            if (e.cellCode === 'sdsA_1_34_1' || e.cellCode === 'sdsA_1_35_1' || e.cellCode === 'sdsA_1_36_1') {
              this.changetableval(
                  'sdsA_1_33_1',
                  'tableDatasvi',
                  this.gettableval('sdsA_1_34_1', 'tableDatasvi') +
                  this.gettableval('sdsA_1_35_1', 'tableDatasvi') +
                  this.gettableval('sdsA_1_36_1', 'tableDatasvi')
              );
            }
            if (e.cellCode === "sdsA_3_1_11") {
              this.changetableval(
                  'sdsA_1_34_1',
                  'tableDatasvi',
                  this.gettableval('sdsA_3_1_11', 'tableDatavx')
              );
            }
            if (e.cellCode === "sdsA_3_2_11") {
              this.changetableval(
                  'sdsA_1_35_1',
                  'tableDatasvi',
                  this.gettableval('sdsA_3_2_11', 'tableDatavx')
              );
            }
          if (e.cellCode === "sdsA_3_3_7") {
            this.changetableval(
                'sdsA_1_37_1',
                'tableDatasvi',
                this.gettableval('sdsA_3_3_7', 'tableDatavx')
            );
          }
          if (e.cellCode === "sdsA_3_3_14") {
            this.changetableval(
                'sdsA_1_38_1',
                'tableDatasvi',
                this.gettableval('sdsA_3_3_14', 'tableDatavx')
            );
          }
          // 实际缴纳企业所得税计算
          if (e.cellCode === "sdsA_1_32_1" || e.cellCode === "sdsA_1_34_1" || e.cellCode === "sdsA_1_35_1" || e.cellCode === "sdsA_1_36_1" || e.cellCode === "sdsA_1_38_1") {
            this.changesdsA_1_38_1_1();
            this.changesdsA_1_38_3_1();
          }
          if (e.cellCode === "sdsA_1_34_1" || e.cellCode === "sdsA_1_35_1") {
            this.changetableval(
                'sdsA_1_38.2_1',
                'tableDatasvii',
                (this.gettableval('sdsA_1_34_1', 'tableDatasvi') +
                    this.gettableval('sdsA_1_35_1', 'tableDatasvi')) * 0.2
            );
          }
          if (e.cellCode === "sdsA_1_38.3_1" || e.cellCode === "sdsA_1_39_1") {
            this.changetableval(
                'sdsA_1_39.3_1',
                'tableDatasvii',
                this.gettableval('sdsA_1_38.3_1', 'tableDatasvii') -
                this.gettableval('sdsA_1_39_1', 'tableDatasvii')
            );
          }
          if (e.cellCode === "sdsA_1_38.1_1" || e.cellCode === "sdsA_1_38.2_1" || e.cellCode === "sdsA_1_39.3_1") {
            this.changetableval(
                'sdsA_1_40_1',
                'tableDatasvii',
                this.gettableval('sdsA_1_38.1_1', 'tableDatasvii') +
                this.gettableval('sdsA_1_38.2_1', 'tableDatasvii') +
                this.gettableval('sdsA_1_39.3_1', 'tableDatasvii')
            );
          }

          // 附表三
          if (e.cellCode === "sdsA_1_27_1" || e.cellCode === "sdsA_1_28_1" || e.cellCode === "sdsA_1_29_1") {
            this.changetableval(
                'sdsA_3_0a_1',
                'tableDataIII',
                this.gettableval('sdsA_1_27_1', 'tableDatasv') -
                this.gettableval('sdsA_1_28_1', 'tableDatasv') -
                this.gettableval('sdsA_1_29_1', 'tableDatasv')
            );
          }
          if (e.cellCode === 'sdsA_3_0a_1' || e.cellCode === 'sdsA_3_0a_2' || e.cellCode === 'sdsA_3_1_7') {
            this.changetableval(
                'sdsA_3_0a_3',
                'tableDataIII',
                (this.gettableval('sdsA_3_0a_1', 'tableDataIII') -
                    this.gettableval('sdsA_3_0a_2', 'tableDataIII')) *
                this.gettableval('sdsA_3_1_7', 'tableDatavx')
            );
          }
          if (e.cellCode === 'sdsA_3_0a_1' || e.cellCode === 'sdsA_3_0a_2' || e.cellCode === 'sdsA_3_2_7') {
            this.changetableval(
                'sdsA_3_0a_4',
                'tableDataIII',
                (this.gettableval('sdsA_3_0a_1', 'tableDataIII') -
                    this.gettableval('sdsA_3_0a_2', 'tableDataIII')) *
                this.gettableval('sdsA_3_2_7', 'tableDatavx')
            );
          }
          if (e.cellCode === 'sdsA_3_0a_1' || e.cellCode === 'sdsA_3_0a_2' || e.cellCode === 'sdsA_3_0a_3' || e.cellCode === 'sdsA_3_0a_4') {
            this.changetableval(
                'sdsA_3_0a_5',
                'tableDataIII',
                this.gettableval('sdsA_3_0a_1', 'tableDataIII') -
                    this.gettableval('sdsA_3_0a_2', 'tableDataIII') -
                    this.gettableval('sdsA_3_0a_3', 'tableDataIII') -
                    this.gettableval('sdsA_3_0a_4', 'tableDataIII')
            );
          }
          if (e.cellCode === "sdsA_3_0a_3") {
            this.changetableval(
                'sdsA_3_1_9',
                'tableDatavx',
                this.gettableval('sdsA_3_0a_3', 'tableDataIII')
            );
          }
          if (e.cellCode === "sdsA_3_1_9" || e.cellCode === "sdsA_3_1_10") {
            let val = this.gettableval('sdsA_3_1_9', 'tableDatavx') - this.gettableval('sdsA_3_1_10', 'tableDatavx');
            if (val < 0) {
              val = 0;
            }
            this.changetableval(
                'sdsA_3_1_11',
                'tableDatavx',
                val
            );
          }
          if (e.cellCode === "sdsA_3_2_9" || e.cellCode === "sdsA_3_2_10") {
            let val = this.gettableval('sdsA_3_2_9', 'tableDatavx') - this.gettableval('sdsA_3_2_10', 'tableDatavx');
            if (val < 0) {
              val = 0;
            }
            this.changetableval(
                'sdsA_3_2_11',
                'tableDatavx',
                val
            );
          }
          if (e.cellCode === "sdsA_3_0a_4") {
            this.changetableval(
                'sdsA_3_2_9',
                'tableDatavx',
                this.gettableval('sdsA_3_0a_4', 'tableDataIII')
            );
          }
          if (lineNumber > 2 && (e.cellCode === "sdsA_3_" + lineNumber + "_4" || e.cellCode === "sdsA_3_1000_4"
              || e.cellCode === "sdsA_3_" + lineNumber + "_5" || e.cellCode === "sdsA_3_1000_5"
              || e.cellCode === "sdsA_3_" + lineNumber + "_6" || e.cellCode === "sdsA_3_1000_6")) {
            this.changetableval(
                "sdsA_3_" + lineNumber + "_7",
                'tableDatavx',
                (this.gettableval("sdsA_3_" + lineNumber + "_4", 'tableDatavx') / this.gettableval('sdsA_3_1000_4', 'tableDatavx')) * 0.35
                    + (this.gettableval("sdsA_3_" + lineNumber + "_5", 'tableDatavx') / this.gettableval('sdsA_3_1000_5', 'tableDatavx')) * 0.35
                    + (this.gettableval("sdsA_3_" + lineNumber + "_6", 'tableDatavx') / this.gettableval('sdsA_3_1000_6', 'tableDatavx')) * 0.3,
                false,
                10
            );
          }
          if (e.cellCode === "sdsA_3_0a_5") {
            this.changeSdsA_3_0a_5();
          }
          if (lineNumber > 2 && (e.cellCode === "sdsA_3_" + lineNumber + "_9" || e.cellCode === "sdsA_3_" + lineNumber + "_10")) {
            let val = this.gettableval("sdsA_3_" + lineNumber + "_9", 'tableDatavx') - this.gettableval("sdsA_3_" + lineNumber + "_10", 'tableDatavx');
            if (val < 0) {
              val = 0;
            }
            this.changetableval(
                "sdsA_3_" + lineNumber + "_11",
                'tableDatavx',
                val
            );
          }
          if (lineNumber > 2 && (e.cellCode === "sdsA_3_" + lineNumber + "_11" || e.cellCode === "sdsA_3_" + lineNumber + "_12")) {
            this.changetableval(
                "sdsA_3_" + lineNumber + "_13",
                'tableDatavx',
                this.gettableval("sdsA_3_" + lineNumber + "_11", 'tableDatavx') *
                this.gettableval("sdsA_3_" + lineNumber + "_12", 'tableDatavx')
            );
          }
          if (lineNumber > 2 && (e.cellCode === "sdsA_3_" + lineNumber + "_11" || e.cellCode === "sdsA_3_" + lineNumber + "_13")) {
            this.changetableval(
                "sdsA_3_" + lineNumber + "_14",
                'tableDatavx',
                this.gettableval("sdsA_3_" + lineNumber + "_11", 'tableDatavx') -
                this.gettableval("sdsA_3_" + lineNumber + "_13", 'tableDatavx')
            );
          }
          if (e.cellCode.substring(0, 6) === 'sdsA_3' && lineNumber > 2 && lineNumber < 1000 && (columnNumber !== "8" && columnNumber !== "12")) {
            this.getsdsA_3_1000(columnNumber);
          }
            //附表二
            if (e.cellCode == 'sdsA_2_1.1_1') {
                this.changetableval(
                    'sdsA_2_1_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.2_1') {
                this.changetableval(
                    'sdsA_2_1_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.3_1') {
                this.changetableval(
                    'sdsA_2_1_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.4_1') {
                this.changetableval(
                    'sdsA_2_1_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.1_2') {
                this.changetableval(
                    'sdsA_2_1_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.2_2') {
                this.changetableval(
                    'sdsA_2_1_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.3_2') {
                this.changetableval(
                    'sdsA_2_1_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.4_2') {
                this.changetableval(
                    'sdsA_2_1_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.1_3') {
                this.changetableval(
                    'sdsA_2_1_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_4', 'tableDataII') - this.gettableval('sdsA_2_1.1_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.2_3') {
                this.changetableval(
                    'sdsA_2_1_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.2_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.2_4', 'tableDataII') - this.gettableval('sdsA_2_1.2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.3_3') {
                this.changetableval(
                    'sdsA_2_1_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.3_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.3_4', 'tableDataII') - this.gettableval('sdsA_2_1.3_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.4_3') {
                this.changetableval(
                    'sdsA_2_1_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.4_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.4_4', 'tableDataII') - this.gettableval('sdsA_2_1.4_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.1_4') {
                this.changetableval(
                    'sdsA_2_1_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_4', 'tableDataII') - this.gettableval('sdsA_2_1.1_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.2_4') {
                this.changetableval(
                    'sdsA_2_1_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.2_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.2_4', 'tableDataII') - this.gettableval('sdsA_2_1.2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.3_4') {
                this.changetableval(
                    'sdsA_2_1_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.3_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.3_4', 'tableDataII') - this.gettableval('sdsA_2_1.3_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.4_4') {
                this.changetableval(
                    'sdsA_2_1_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_1.4_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.4_4', 'tableDataII') - this.gettableval('sdsA_2_1.4_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.1_5') {
                this.changetableval(
                    'sdsA_2_1_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.2_5') {
                this.changetableval(
                    'sdsA_2_1_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.3_5') {
                this.changetableval(
                    'sdsA_2_1_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.4_5') {
                this.changetableval(
                    'sdsA_2_1_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.3_6') {
                this.changetableval(
                    'sdsA_2_1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_6', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_6', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_6', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_6', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1.4_6') {
                this.changetableval(
                    'sdsA_2_1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1.1_6', 'tableDataII') +
                        this.gettableval('sdsA_2_1.2_6', 'tableDataII') +
                        this.gettableval('sdsA_2_1.3_6', 'tableDataII') +
                        this.gettableval('sdsA_2_1.4_6', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_4') {
                this.changetableval(
                    'sdsA_2_1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_4', 'tableDataII') - this.gettableval('sdsA_2_1_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_3') {
                this.changetableval(
                    'sdsA_2_1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_4', 'tableDataII') - this.gettableval('sdsA_2_1_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.1_1') {
                this.changetableval(
                    'sdsA_2_2_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.2_1') {
                this.changetableval(
                    'sdsA_2_2_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.3_1') {
                this.changetableval(
                    'sdsA_2_2_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.4_1') {
                this.changetableval(
                    'sdsA_2_2_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.5_1') {
                this.changetableval(
                    'sdsA_2_2_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.6_1') {
                this.changetableval(
                    'sdsA_2_2_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_1', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.1_2') {
                this.changetableval(
                    'sdsA_2_2_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.2_2') {
                this.changetableval(
                    'sdsA_2_2_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.3_2') {
                this.changetableval(
                    'sdsA_2_2_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.4_2') {
                this.changetableval(
                    'sdsA_2_2_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.5_2') {
                this.changetableval(
                    'sdsA_2_2_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.6_2') {
                this.changetableval(
                    'sdsA_2_2_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_2', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.1_3') {
                this.changetableval(
                    'sdsA_2_2_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') - this.gettableval('sdsA_2_2.1_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.2_3') {
                this.changetableval(
                    'sdsA_2_2_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.2_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.2_4', 'tableDataII') - this.gettableval('sdsA_2_2.2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.3_3') {
                this.changetableval(
                    'sdsA_2_2_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.3_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.3_4', 'tableDataII') - this.gettableval('sdsA_2_2.3_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.4_3') {
                this.changetableval(
                    'sdsA_2_2_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.4_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.4_4', 'tableDataII') - this.gettableval('sdsA_2_2.4_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.5_3') {
                this.changetableval(
                    'sdsA_2_2_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.5_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.5_4', 'tableDataII') - this.gettableval('sdsA_2_2.5_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.6_3') {
                this.changetableval(
                    'sdsA_2_2_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_3', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.6_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.6_4', 'tableDataII') - this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.1_4') {
                this.changetableval(
                    'sdsA_2_2_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.1_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') - this.gettableval('sdsA_2_2.1_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.2_4') {
                this.changetableval(
                    'sdsA_2_2_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.2_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.2_4', 'tableDataII') - this.gettableval('sdsA_2_2.2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.3_4') {
                this.changetableval(
                    'sdsA_2_2_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.3_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.3_4', 'tableDataII') - this.gettableval('sdsA_2_2.3_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.4_4') {
                this.changetableval(
                    'sdsA_2_2_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.4_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.4_4', 'tableDataII') - this.gettableval('sdsA_2_2.4_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.5_4') {
                this.changetableval(
                    'sdsA_2_2_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.5_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.5_4', 'tableDataII') - this.gettableval('sdsA_2_2.5_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.6_4') {
                this.changetableval(
                    'sdsA_2_2_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_4', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_4', 'tableDataII')
                );
                this.changetableval(
                    'sdsA_2_2.6_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.6_4', 'tableDataII') - this.gettableval('sdsA_2_2.6_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.1_5') {
                this.changetableval(
                    'sdsA_2_2_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.2_5') {
                this.changetableval(
                    'sdsA_2_2_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.3_5') {
                this.changetableval(
                    'sdsA_2_2_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.4_5') {
                this.changetableval(
                    'sdsA_2_2_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.5_5') {
                this.changetableval(
                    'sdsA_2_2_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.6_5') {
                this.changetableval(
                    'sdsA_2_2_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_2.1_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.2_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.3_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.4_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.5_5', 'tableDataII') +
                        this.gettableval('sdsA_2_2.6_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2.1_6') {
                this.changetableval(
                    'sdsA_2_2_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_2_4', 'tableDataII') + this.gettableval('sdsA_2_2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_1') {
                this.changetableval(
                    'sdsA_2_3_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_1', 'tableDataII') + this.gettableval('sdsA_2_2_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2_1') {
                this.changetableval(
                    'sdsA_2_3_1',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_1', 'tableDataII') + this.gettableval('sdsA_2_2_1', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_2') {
                this.changetableval(
                    'sdsA_2_3_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_2', 'tableDataII') + this.gettableval('sdsA_2_2_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2_2') {
                this.changetableval(
                    'sdsA_2_3_2',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_2', 'tableDataII') + this.gettableval('sdsA_2_2_2', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_3') {
                this.changetableval(
                    'sdsA_2_3_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_3', 'tableDataII') + this.gettableval('sdsA_2_2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2_3') {
                this.changetableval(
                    'sdsA_2_3_3',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_3', 'tableDataII') + this.gettableval('sdsA_2_2_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_4') {
                this.changetableval(
                    'sdsA_2_3_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_4', 'tableDataII') + this.gettableval('sdsA_2_2_4', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2_4') {
                this.changetableval(
                    'sdsA_2_3_4',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_4', 'tableDataII') + this.gettableval('sdsA_2_2_4', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_1_5') {
                this.changetableval(
                    'sdsA_2_3_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_5', 'tableDataII') + this.gettableval('sdsA_2_2_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_2_5') {
                this.changetableval(
                    'sdsA_2_3_5',
                    'tableDataII',
                    this.gettableval('sdsA_2_1_5', 'tableDataII') + this.gettableval('sdsA_2_2_5', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_3_3') {
                this.changetableval(
                    'sdsA_2_3_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_3_4', 'tableDataII') + this.gettableval('sdsA_2_3_3', 'tableDataII')
                );
            }
            if (e.cellCode == 'sdsA_2_3_4') {
                this.changetableval(
                    'sdsA_2_3_6',
                    'tableDataII',
                    this.gettableval('sdsA_2_3_4', 'tableDataII') + this.gettableval('sdsA_2_3_3', 'tableDataII')
                );
            }
        },
        changeqiylx(e) {
          this.changesdsA_1_38_1_1();
          this.changesdsA_1_38_3_1();
          if (e.qiylx === "2") {
            this.tableDatasv.map((item) => {
              if (
                  item.sdsA_1_x_1.cellCode === 'sdsA_1_1_1' ||
                  item.sdsA_1_x_1.cellCode === 'sdsA_1_2_1' ||
                  item.sdsA_1_x_1.cellCode === 'sdsA_1_3_1'
              ) {
                item.sdsA_1_x_1.cellVal = '0.00';
              }
              if (
                  item.sdsA_1_x_2.cellCode === 'sdsA_1_1_1' ||
                  item.sdsA_1_x_2.cellCode === 'sdsA_1_2_1' ||
                  item.sdsA_1_x_2.cellCode === 'sdsA_1_3_1'
              ) {
                item.sdsA_1_x_2.cellVal = '0.00';
              }
            });
          }
        },
        changesdsA_1_38_1_1() {
          if (this.headobj.qiylx === "0") {
            this.changetableval('sdsA_1_38.1_1', 'tableDatasvii', this.gettableval('sdsA_1_32_1', 'tableDatasv') * 0.6);
          }
          if (this.headobj.qiylx === "1") {
            this.changetableval(
                'sdsA_1_38.1_1',
                'tableDatasvii',
                (this.gettableval('sdsA_1_34_1', 'tableDatasvi') + this.gettableval('sdsA_1_35_1', 'tableDatasvi') + this.gettableval('sdsA_1_36_1', 'tableDatasvi')) * 0.6
            );
          }
          if (this.headobj.qiylx === "2") {
            this.changetableval('sdsA_1_38.1_1', 'tableDatasvii', this.gettableval('sdsA_1_38_1', 'tableDatasvi') * 0.6);
          }
        },
        changesdsA_1_38_3_1() {
          if (this.headobj.qiylx === "0") {
            this.changetableval('sdsA_1_38.3_1', 'tableDatasvii', this.gettableval('sdsA_1_32_1', 'tableDatasv') * 0.4);
          }
          if (this.headobj.qiylx === "1") {
            this.changetableval(
                'sdsA_1_38.3_1',
                'tableDatasvii',
                (this.gettableval('sdsA_1_34_1', 'tableDatasvi') + this.gettableval('sdsA_1_35_1', 'tableDatasvi')) * 0.2
            );
          }
          if (this.headobj.qiylx === "2") {
            this.changetableval('sdsA_1_38.3_1', 'tableDatasvii', this.gettableval('sdsA_1_38_1', 'tableDatasvi') * 0.4);
          }
        },
        yjfschange(e) {
          if (e === "0") {
            // 若prepayMethod“按照实际利润额预缴”，sdsA_1_25_1=sdsA_1_18_1 + sdsA_1_19_1 - sdsA_1_20_1 - sdsA_1_21_1 - sdsA_1_22_1 - sdsA_1_23_1 - sdsA_1_24_1
            this.changetableval(
                'sdsA_1_25_1',
                'tableDatasv',
                this.gettableval('sdsA_1_18_1', 'tableDatasv') +
                this.gettableval('sdsA_1_19_1', 'tableDatasv') -
                this.gettableval('sdsA_1_20_1', 'tableDatasv') -
                this.gettableval('sdsA_1_21_1', 'tableDatasv') -
                this.gettableval('sdsA_1_22_1', 'tableDatasv') -
                this.gettableval('sdsA_1_23_1', 'tableDatasv') -
                this.gettableval('sdsA_1_24_1', 'tableDatasv')
            );
            // 若prepayMethod“按照实际利润额预缴”，sdsA_1_32_1=sdsA_1_27_1-sdsA_1_28_1-sdsA_1_29_1-sdsA_1_30_1-sdsA_1_31_1；如果（sdsA_1_27_1-sdsA_1_28_1-sdsA_1_29_1-sdsA_1_30_1-sdsA_1_31_1）< 0 ，本格=0；
            let val = this.gettableval('sdsA_1_27_1', 'tableDatasv') -
                this.gettableval('sdsA_1_28_1', 'tableDatasv') -
                this.gettableval('sdsA_1_29_1', 'tableDatasv') -
                this.gettableval('sdsA_1_30_1', 'tableDatasv') -
                this.gettableval('sdsA_1_31_1', 'tableDatasv');
            if (val < 0) {
              val = 0;
            }
            this.changetableval(
                'sdsA_1_32_1',
                'tableDatasv',
                val
            );
          } else if (e === "2") {
            // 若prepayMethod“按照税务机关确定的其他方法预缴”，sdsA_1_32_1= sdsA_1_27_1
            this.changetableval(
                'sdsA_1_32_1',
                'tableDatasv',
                this.gettableval('sdsA_1_27_1', 'tableDatasv')
            );
          }
        },
        getsdsA_1_22_1() {
          let total = 0;
          let all = this.filternums(this.tableDatasv, this.IHead);
          all.forEach((item) => {
            // 列号
            let columnNumber = item.cellCode.substring(item.cellCode.lastIndexOf('_') + 1);
            // 行号
            let lineNumber = item.cellCode.substring(7, item.cellCode.lastIndexOf('_'));
            if (item.cellCode.substring(0, 6) === 'sdsA_1' && lineNumber > 22 && lineNumber < 23 && columnNumber === "2") {
              total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
            }
          });
          this.changetableval('sdsA_1_22_1', 'tableDatasv', total);
        },
        getsdsA_1_23_1() {
          let total = 0;
          let all = this.filternums(this.tableDatasv, this.IHead);
          all.forEach((item) => {
            // 列号
            let columnNumber = item.cellCode.substring(item.cellCode.lastIndexOf('_') + 1);
            // 行号
            let lineNumber = item.cellCode.substring(7, item.cellCode.lastIndexOf('_'));
            if (item.cellCode.substring(0, 6) === 'sdsA_1' && lineNumber > 23 && lineNumber < 24 && columnNumber === "2") {
              total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
            }
          });
          this.changetableval('sdsA_1_23_1', 'tableDatasv', total);
        },
        getsdsA_1_28_1_2(e) {
            let Code = '';
            let len = '';
            let code = '';
            let value = '';
            let value2 = '';
            let all = this.filternums(this.tableDatasv, this.IHead);
            let setlist = new Array()
            all.map(item => {
                if (item.cellCode.substring(7, 10) == '28.' && 
                    item.cellCode.substring(item.cellCode.lastIndexOf('_')+1) == '1') {
                        Code = item.cellCode.substring(10, item.cellCode.length - 1);
                        len = 10 + Code.split('_').length - 1;
                        code = item.cellCode.substring(0, len) + '_2';
                        let code1 = item.cellCode.substring(0, len) + '_1';
                        if (item.cellCode == code1) {
                            value = item.cellVal;
                        } else if (item.cellCode == code) {
                            value2 = item.cellVal;
                        }
                    
                    if(value == '符合条件的小型微利企业减免企业所得税') {
                        if((item.cellCode == code) && value2!=null&&value2!='0') {
                            item.cellType = '1';
                        }
                        if(!setlist.includes(code1)) {
                            if (this.gettableval('sdsA_1_25_1', 'tableDatasv') > 0) {
                                this.changetableval(code, 'tableDatasv', this.gettableval('sdsA_1_25_1', 'tableDatasv') * 0.25 * 0.8);
                            } else {
                                this.changetableval(code, 'tableDatasv', 0);
                            }
                            setlist.push(code1);
                        }
                    } else if (value == '国家需要重点扶持的高新技术企业减按15%的税率征收企业所得税') {
                        if(item.cellCode == code && value2!=null&&value2!='0') {
                            item.cellType = '1';
                        }
                        if(!setlist.includes(code1)) {
                            if (this.gettableval('sdsA_1_25_1', 'tableDatasv') > 0) {
                                this.changetableval(code, 'tableDatasv', this.bankersRound(this.multiply(this.gettableval('sdsA_1_25_1', 'tableDatasv'), 0.1), 2));
                            } else {
                                this.changetableval(code, 'tableDatasv', 0);
                            }
                            setlist.push(code1);
                        }
                    } else if (value == '国家鼓励的软件企业减免企业所得税' && this.gettableval('sdsA_1_0d_1', 'tableDatas') === 'Y') {
                        if(!setlist.includes(code1)) {
                            this.changetableval(code, 'tableDatasv', this.gettableval('sdsA_1_27_1','tableDatasv'))
                            setlist.push(code1);
                        }
                    }
                }
            });
            all.map(item => {
                if(item.cellCode == 'sdsA_1_25_1' || item.cellCode == 'sdsA_1_28_1') {
                    if(setlist.length> 0) {
                        item.cellType = '1'
                    } else {
                        item.cellType = '0'
                    }
                }
                
                if(setlist.includes(item.cellCode)) {
                    item.cellType = '1'
                }
            });
        },
        getsdsA_1_28_1() {
          let total = 0;
          let all = this.filternums(this.tableDatasv, this.IHead);
          all.forEach((item) => {
            // 列号
            let columnNumber = item.cellCode.substring(item.cellCode.lastIndexOf('_') + 1);
            // 行号
            let lineNumber = item.cellCode.substring(7, item.cellCode.lastIndexOf('_'));
            if (item.cellCode.substring(0, 6) === 'sdsA_1' && lineNumber > 28 && lineNumber < 29 && columnNumber === "2") {
              total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
            }
          });
          this.changetableval('sdsA_1_28_1', 'tableDatasv', total);
        },
        getsdsA_1_29_1() {
          let total = 0;
          let all = this.filternums(this.tableDatasv, this.IHead);
          all.forEach((item) => {
            // 列号
            let columnNumber = item.cellCode.substring(item.cellCode.lastIndexOf('_') + 1);
            // 行号
            let lineNumber = item.cellCode.substring(7, item.cellCode.lastIndexOf('_'));
            if (item.cellCode.substring(0, 6) === 'sdsA_1' && lineNumber > 29 && lineNumber < 30 && columnNumber === "2") {
              total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
            }
          });
          this.changetableval('sdsA_1_29_1', 'tableDatasv', total);
        },
        getsdsA_3_1000(columnNumber) {
            let total = 0;
            let all = this.filternums(this.tableDatavx, this.IIIHead);
            all.forEach((item) => {
                let lineNumber = item.cellCode.substring(7, item.cellCode.lastIndexOf('_'));
                if (lineNumber > 2 && item.cellCode.substring(7, item.cellCode.lastIndexOf('_')) !== "1000" && item.cellCode.substring(0, 6) === 'sdsA_3' && item.cellCode.substring(item.cellCode.lastIndexOf('_') + 1) === columnNumber) {
                    total = parseFloat(this.$isNumber(item.cellVal) ? item.cellVal : 0) + total;
                }
            });
            this.changetableval("sdsA_3_1000_" + columnNumber, 'tableDatavx', total);
        },
        changeSdsA_3_0a_5() {
          let all = this.filternums(this.tableDatavx, this.IIIHead);
          all.forEach((item) => {
            if (item.cellCode.endsWith("_7") && !item.cellCode.endsWith("_1000_7") && !item.cellCode.endsWith("_1_7") && !item.cellCode.endsWith("_2_7")) {
              this.changetableval(item.cellCode.substring(0, item.cellCode.length - 1) + "9", 'tableDatavx', this.gettableval('sdsA_3_0a_5', 'tableDataIII') * this.gettableval(item.cellCode, 'tableDatavx'));
            //   this.changetableval(item.cellCode.substring(0, item.cellCode.length - 1) + "10", 'tableDatavx', this.gettableval('sdsA_3_0a_5', 'tableDataIII') * this.gettableval(item.cellCode, 'tableDatavx'));
            }
          });
        },
        gettableval(changecode, table, old) {
            var head = '';
            if (
                table == 'tableDataI' ||
                table == 'tableDatas' ||
                table == 'tableDatasv' ||
                table == 'tableDatasvi' ||
                table == 'tableDatasvii'
            ) {
                head = 'IHead';
            }
            if (table == 'tableDataIII' || table == 'tableDatavx') {
                head = 'IIIHead';
            }
            if (table == 'tableDataII') {
                head = 'IIHead';
            }
            let a;
            if (this[table] && this[head]) {
              for (let i = 0; i < this[table].length; i++) {
                for (let j = 0; j < this[head].length; j++) {
                  if (
                      this[table][i][this[head][j]] &&
                      this[table][i][this[head][j]].cellCode &&
                      this[table][i][this[head][j]].cellVal &&
                      this[table][i][this[head][j]].cellCode == changecode
                  ) {
                    if (old) {
                      if (this.$emptyandnull(this[table][i][this[head][j]].goujgxValue)) {
                        a = 0;
                      } else {
                        a = parseFloat(this[table][i][this[head][j]].goujgxValue);
                      }
                    } else {
                      if (this[table][i][this[head][j]].cellVal == '-') {
                        a = 0;
                      } else {
                        if (changecode == 'sdsA_1_0d_1' || changecode == 'sdsA_1_0e_1') {
                          a = this[table][i][this[head][j]].cellVal || 0;
                        } else {
                          a = parseFloat(this[table][i][this[head][j]].cellVal || 0);
                        }
                      }
                    }
                    break;
                  }
                }
              }
            }
            a = a || 0;
            return a;
        },
        changetableval(changecode, table, newval, checkq, digit) {
            var newval = newval || 0;

            if (digit) {
                newval = this.toFixed(newval, digit);
            } else{
				newval = this.toFixed(newval, 2);
			}
            var head = '';
            if (
                table == 'tableDataI' ||
                table == 'tableDatas' ||
                table == 'tableDatasv' ||
                table == 'tableDatasvi' ||
                table == 'tableDatasvii'
            ) {
                head = 'IHead';
            }
            if (table == 'tableDataIII' || table == 'tableDatavx') {
                head = 'IIIHead';
            }
            if (table == 'tableDataII') {
                head = 'IIHead';
            }

            for (let i = 0; i < this[table].length; i++) {
                for (let j = 0; j < this[head].length; j++) {
                    if (
                        this[table][i][this[head][j]] &&
                        this[table][i][this[head][j]].cellCode &&
                        typeof this[table][i][this[head][j]].cellVal != 'undefined' &&
                        typeof this[table][i][this[head][j]].cellVal != undefined &&
                        this[table][i][this[head][j]].cellCode == changecode
                    ) {
                        if (this[table][i][this[head][j]].cellVal != newval) {
                            if (this.suosq.substring(4, 6) < 5 && checkq) {
                                this[table][i][this[head][j]].cellVal = '';
                            } else {
                                this[table][i][this[head][j]].cellVal = newval + '';
                            }
                            this.inputblur({
                                cellCode: changecode,
                                cellVal: newval
                            });
                            break;
                        }
                    }
                }
            }
        },
        
	  // 出口收入差异情况表
			exportIncomeDifference() {
				this.exportIncomeDifferenceDiag = true;
			},
			closeExportIncomeDifferenceDiag(e) {
				this.exportIncomeDifferenceDiag = false;
			},
			confirmExportIncomeDifference(e) {
				this.exportIncomeDifferenceDiag = false;
			},
    }
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
